<template>
    <div class="border-b border-gray-400 pt-8 pb-2">
        <form-row title="Agent/Broker" :no_border="true" class="mb-10">
            <div class="sm:col-gap-2 flex-1 mb-2 sm:-mt-4">
                <input-text
                    label="Name"
                    name="sales_broker_name"
                    :value="broker.name"
                    tabindex="-1"
                    :read_only="true"
                />
            </div>

            <div class="sm:col-gap-2 flex-1 mb-2 sm:-mt-4">
                <input-text
                    label="MLS#"
                    name="sales_broker_mls"
                    :value="broker.mls_number"
                    placeholder="#"
                    tabindex="-1"
                    :read_only="true"
                />
            </div>
        </form-row>

        <form-row title="Office" :no_border="true" class="mb-6">
            <div class="sm:col-gap-2 flex-1 mb-2 sm:-mt-4">
                <input-text
                    label="Office Name"
                    name="office_name"
                    v-model="office_name"
                    placeholder="Name"
                    :read_only="read_only"
                />
            </div>

            <div class="sm:col-gap-2 flex-1 mb-2 sm:-mt-4">
                <input-text
                    label="Office ID"
                    name="office_number"
                    v-model="office_number"
                    placeholder="#"
                    :read_only="read_only"
                />
            </div>
        </form-row>
    </div>
</template>

<script>
export default {
    props: {
        broker: { default: () => ({}) },
        read_only: { default: false },
    },

    computed: {
        office_name: {
            get() {
                return store.state.office_name;
            },
            set(val) {
                store.state.office_name = val;
            },
        },
        office_number: {
            get() {
                return store.state.office_number;
            },
            set(val) {
                store.state.office_number = val;
            },
        },
    },
}
</script>
